export enum pages {
  DASHBOARD = "Dashboard",
  COCKPIT = "Cockpit",
  ORDERS = "Pedidos",
  QUOTES = "Cotações",
  MISSING_LETTERS = "Cartas de Falta",
  PRODUCTS = "Consulta de Produtos",
  USER_MANAGER = "Alterar Cadastro",
}

export enum actions {
  INVOICE = "Nota Fiscal",
  BILLET = "Boleto",
  RECEIPT = "Comprovante de Entrega",
  XML = "XMl Nota Fiscal",
  BILLED_ORDERS = "Pedidos Faturados",
  PENDING_ORDERS = "Pedidos Pendentes",
}

export enum note {
  DOWNLOAD = "Download",
  TAB = "Aba",
  BUTTON = "Botão",
  LIGHTBOX = "Light Box",
}

export enum platforms {
  CCARE = "CCare",
  AUTOMACAO = "AUTOMACAO"
}

export const urlsAutomacao = [
  'cotacoes-dashboard',
  'cotacoes-nova',
  'cotacoes-sugestao',
  'cotacoes-sem-depara',
  'enviadas',
  'esperando-gravacao',
  'produtos-fora-do-portfolio',
  'expiram-hoje',
  'expiradas-nao-respondidas',
  'respondidas-aguardando-retorno'
];

export enum eventName {
  ABRIR_PROTOCOLO = "Abrir Protocolo",
  PROTOCOLOS = "Protocolos",
  PEDIDOS = "Pedidos",
  COTACOES = "Cotações",
  DETALHES_DO_PEDIDO = "Detalhes do pedido",
  ALTERAR_CADASTRO = "Alterar Cadastro",
  RELATORIOS_EXPRESSA = "Relatórios Expressa",
  GERENCIAR_USUARIOS_VIVEO = "Gerenciar Usuários Viveo",
  GERENCIAR_USUARIOS = "Gerenciar Usuários",
  CARTAS_DE_FALTA = "Cartas de Falta",
  DESLOGAR = "Deslogar",
  CHATBOT = "ChatBot",
  BOLETO = "Boleto",
  NOTA_FISCAL = "Nota Fiscal",
  NOTA_FISCAL_REMESSA = "Nota Fiscal Remessa",
  PREVISAO_DE_ENTREGA = "Previsão de Entrega",
  COMPROVANTE_DE_ENTREGA = "Comprovante de Entrega",
  COMPROVANTE_DE_ENTREGA_REMESSA = "Comprovante de Entrega Remessa",
  FICHA_TECNICA = "Ficha Técnica",
  LAUDO_TECNICO = "Laudo Técnico",
  DASHBOARD_CLIENTE = "Dashboard Cliente",
  SIDEBAR_PORTAL = "Sidebar Portal",
  COCKPIT_CLIENTE = "Cockpit Cliente",
  ESTATISTICAS_CLIENTE = "Estatísticas Cliente",
  PRODUTOS = "Produtos",
  RELATORIOS = "Relatórios",
  TRACKING_PEDIDO = "Tracking do Pedido",
  DEVOLUCAO_NFE = "Devolução NFE",
  NOTAS_DASH_CLIENTE = "Notas do Cliente",
  ADD_ARQUIVO_DASH_CLIENTE = "Arquivo Cliente",
  NOTA_DE_CORRECAO = "Carta de Correção",
  DOWNLOAD_RELATORIOS_EXPRESSA = "Download Relatórios Expressa",
  DADOS_CLIENTE = "Dados do Cliente",
  UPDATE_LEGAL_DOCUMENT = "Atualização de Documentos Legais",
  DOWNLOAD_REPORTS_USERS = "Download Relatório de Usuários",
  DOWNLOAD_REPORTS_LEGAL_DOCUMENTS = "Download Relatório de Documentos Legais",
  DOWNLOAD_REPORTS_QUALIFICATIONS = "Download Relatório de Qualificações",
  DOWNLOAD_REPORTS_CONSOLIDATED_PROTOCOLS = "Download Relatório de Protocolos Consolidados",
  DOWNLOAD_REPORTS_NPS_LOJAS_FISICAS = "Download Relatório NPS Lojas Físicas",
  COVERAGE = "Relatório de Teste",
  TRANSPORTADORA = "Transportadora",
  DOWNLOAD_CTE = "Download CTE",
  XML_CTE = "XML CT-e",
  COCKPIT_FORNECEDOR = "Cockpit Fornecedor",
}

export enum abrirProtocoloAction {
  HEADER_ABRIRPROTOCOLO = 'Header_AbrirProtocolo',
  MENU_ABRIRPROTOCOLO = 'Menu_AbrirProtocolo',
  REGISTRARPROTOCOLO = 'RegistrarProtocolo',
  REGISTRARPROTOCOLOSIMPLES = 'RegistrarProtocoloSimples',
  REGISTRAR_TRACKING_INDISPONIVEL = 'Tracking_Indisponivel'
}

export enum protocolosAction {
  HEADER_PROTOCOLOS = 'Header_Protocolos',
  MENU_PROTOCOLOS = 'Menu_Protocolos',
  ABA_DASHBOARD_PROTOCOLOSABERTOS = 'Aba_Dashboard_ProtocolosAbertos',
  ABA_DASHBOARD_PROTOCOLOSFECHADOS = 'Aba_Dashboard_ProtocolosFechados',
  LINK_DASHBOARD_VERTODOSPROTOCOLOS = 'Link_Dashboard_VerTodosProtocolos',
  DASHBOARD_VISUALIZARPROTOCOLO = 'Dashboard_VisualizarProtocolo',
  VISUALIZARPROTOCOLO = 'VisualizarProtocolo',
  EDITARPROTOCOLO = 'EditarProtocolo',
}

export enum pedidosAction {
  HEADER_PEDIDOS = 'Header_Pedidos',
  MENU_PEDIDOS = 'Menu_Pedidos',
  ABA_DASHBOARD_PEDIDOSFATURADOS = 'Aba_Dashboard_PedidosFaturados',
  ABA_DASHBOARD_PEDIDOSPENDENTES = 'Aba_Dashboard_PedidosPendentes',
  ABA_DASHBOARD_VENDATRIANGULAR = 'Aba_Dashboard_VendaTriangular',
  LINK_DASHBOARD_VERTODOSPEDIDOS = 'Link_Dashboard_VerTodosPedidos',
  ABA_PEDIDOSFATURADOS = 'Aba_PedidosFaturados',
  ABA_PEDIDOSPENDENTES = 'Aba_PedidosPendentes',
  DASHBOARD_VISUALIZARPEDIDO = 'Dashboard_VisualizarPedido',
  VISUALIZARPEDIDO = 'VisualizarPedido',
  HEADER_COTACOES = 'Header_Cotações'
}

export enum cotacoesAction {
  HEADER_COTACOES = 'Header_Cotações',
  MENU_COTACOES = 'Menu_Cotações',
  ABA_DASHBOARD_COTACOES = 'Aba_Dashboard_Cotações',
  LINK_DASHBOARD_VERTODASCOTACOES = 'Link_Dashboard_VerTodasCotações',
  VISUALIZARCOTACAO = 'VisualizarCotação',
  DASH_PORTAL_COTACOES = 'Dashboard_Portal_Cotações',
}

export enum dadosClienteAction {
  MENU_DADOSCLIENTE = 'Menu_DadosCliente',
  MENU_RELATORIOSTESTE = 'Menu_RelatoriosTeste'
}

export enum alterarCadastroAction {
  MENU_ALTERARCADASTRO = 'Menu_AlterarCadastro',
}


export enum gerenciarUsuariosViveoAction {
  MENU_GERENCIARUSUARIOSVIVEO = 'Menu_GerenciarUsuáriosViveo',
}

export enum gerenciarUsuariosAction {
  MENU_GERENCIARUSUARIOS = 'Menu_GerenciarUsuários',
}

export enum cartasDeFaltaAction {
  MENU_CARTASDEFALTA = 'Menu_CartasDeFalta',
  REGISTRARCARTADEFALTA = 'RegistrarCartaDeFalta',
}

export enum deslogarAction {
  MENU_DESLOGAR = 'Menu_Deslogar',
}

export enum chatbotAction {
  CHATBOT = 'ChatBot',
}

export enum boletoAction {
  DASHBOARD_BOLETO = 'Dashboard_Boleto',
  PEDIDO_BOLETO = 'Pedido_Boleto',
  DETALHE_BOLETO = 'Detalhe_Boleto',
  DASHCLIENTE_BOLETO = 'DashCliente_Boleto',
  DOWNLOAD_LOTE_BOLETO = 'Download_Lote_Boleto',
  CTE_BOLETO = 'Cte_Boleto',
}

export enum notaFiscalAction {
  DASHBOARD_NOTAFISCAL_PDF = 'Dashboard_NotaFiscal_PDF',
  DASHBOARD_NOTAFISCAL_REMESSA_PDF = 'Dashboard_NotaFiscal_Remessa_PDF',
  DASHBOARD_NOTAFISCAL_XML = 'Dashboard_NotaFiscal_XML',
  PEDIDO_NOTAFISCAL_PDF = 'Pedido_NotaFiscal_PDF',
  PEDIDO_NOTAFISCAL_XML = 'Pedido_NotaFiscal_XML',
  PEDIDO_NOTAFISCAL_REMESSA_PDF = 'Pedido_NotaFiscal_Remessa_PDF',
  DASHBOARD_NOTAFISCAL_REMESSA_XML = 'Dashboard_NotaFiscal_Remessa_XML',
  PEDIDO_NOTAFISCAL_REMESSA_XML = 'Pedido_NotaFiscal_Remessa_XML',
  COCKPIT_NOTAFISCAL_REMESSA_XML = 'Cockpit_NotaFiscal_Remessa_XML',
  DETALHE_NOTAFISCAL_PDF = 'Detalhe_NotaFiscal_PDF',
  DETALHE_NOTAFISCAL_XML = 'Detalhe_NotaFiscal_XML',
  DETALHE_NOTAFISCAL_REMESSA_XML = 'Detalhe_NotaFiscal_Remessa_XML',
  DETALHE_NOTAFISCAL_REMESSA = 'Detalhe_NotaFiscal_Remessa',
  NOTA_DEVOLUCAO_PDF = 'Nota_Devolucão_PDF',
  NOTA_DEVOLUCAO_XML = 'Nota_Devolucão_XML',
  DASHCLIENTE_NOTAFISCAL_PDF = 'DashCliente_NotaFiscal_PDF',
  NOTA_REMESSA = 'Nota_Remessa',
  DOWNLOAD_LOTE_PDF = 'Download_Lote_PDF',
  DOWNLOAD_LOTE_XML = 'Download_Lote_XML',
  COCKPIT_NOTAFISCAL_REMESSA_PDF = 'Cockpit_NotaFiscal_Remessa_PDF',
  CTE_NOTAFISCAL_PDF = 'Cte_NotaFiscal_PDF',
  CTE_NOTAFISCAL_XML = 'Cte_NotaFiscal_XML',
  DASHBOARD_NOTAFISCAL_CTE = 'Dashboard_NotaFiscal_CTE',
  DASHBOARD_NOTAFISCAL_CTE_XML = 'Dashboard_NotaFiscal_CTE_XML'
}

export enum notaCorrecaoAction {
  NOTA_CORRECAO = 'Carta_Correção',
  DASHCLIENTE_NOTADECORRECAO = 'DashCliente_CartaCorrecao',
}

export enum comprovanteDeEntregaAction {
  PEDIDO_COMPROVANTEENTREGA = 'Pedido_ComprovanteEntrega',
  DASHCLIENTE_COMPROVANTEENTREGA = 'DashCliente_ComprovanteEntrega',
  DASHCLIENTE_COMPROVANTEENTREGA_REMESSA = 'DashCliente_ComprovanteEntrega_Remessa',
  PEDIDO_COMPROVANTEENTREGA_REMESSA = 'Pedido_ComprovanteEntrega_Remessa',
  COCKPIT_COMPROVANTEENTREGA_REMESSA = 'Cockpit_ComprovanteEntrega_Remessa',
  DOWNLOAD_LOTE_COMPROVANTEENTREGA_REMESSA = 'Download_Lote_ComprovanteEntrega_Remessa',
}

export enum fichaTecnicaAction {
  PEDIDO_FICHATECNICA = 'Pedido_FichaTécnica',
  DASHCLIENTE_FICHATECNICA = 'DashCliente_FichaTécnica'
}

export enum laudoTecnicoAction {
  PEDIDO_LAUDOTECNICO = 'Pedido_LaudoTécnico',
  DASHCLIENTE_LAUDOTECNICO = 'DashCliente_LaudoTécnico',
}

export enum dashboardClienteAction {
  DASHCLIENTE_SEGUNDAVIABOLETO = 'DashCliente_SegundaViaBoleto',
  DASHCLIENTE_CONSULTACTE = 'DashCliente_ConsultaCte',
  DASHCLIENTE_CONSULTAFATURA = 'DashCliente_ConsultaFatura',
  DASHCLIENTE_CONSULTAESTOQUE = 'DashCliente_ConsultaEstoque',
  DASHCLIENTE_TRACKINGPEDIDO = 'DashCliente_TrackingPedido',
  DASHCLIENTE_NOTASFISCAIS = 'DashCliente_NotasFiscais',
  DASHCLIENTE_XMLNFE = 'DashCliente_XMLNFe',
  DASHCLIENTE_XMLCTE = 'DashCliente_XMLCTe',
  DASHCLIENTE_LAUDOSFICHAS = 'DashCliente_LaudosFichas',
  DASHCLIENTE_COMPROVANTEENTREGA = 'DashCliente_ComprovanteEntrega',
  DASHCLIENTE_FALARCOMPRESIDENTE = 'DashCliente_FalarComPresidente',
  DASHCLIENTE_NOTACORRECAO = 'DashCliente_CartaCorrecao',
  DASHCLIENTE_DOCUMENTOSLEGAIS = 'DashCliente_DocumentosLegais',
  DASHCLIENTE_DOCUMENTOSREGULATORIOS = 'DashCliente_DocumentosRegulatorios',
  DASHCLIENTE_CONSULTAPRODUTOS = 'DashCliente_ConsultaProdutos',
  DASHCLIENTE_SOLICITARDEVOLUCAO = 'DashCliente_SolicitarDevolução',
  DASHCLIENTE_RECLAMACAOTECNICA = 'DashCliente_ReclamaçãoTécnica',
  DASHCLIENTE_GERENCIARUSUARIOS = 'DashCliente_GerenciarUsuários',
  DASHCLIENTE_POLITICASNEGOCIO = 'DashCliente_PolíticasNegócio',
  DASHCLIENTE_FALECOMNUTRICIONISTA = "DashCliente_FaleComNutricionista",
  DASHCLIENTE_FOLLOWUPENTREGAS = "DashCliente_FollowUpEntregas",
  DASHCLIENTE_FOLLOWUPNAOENTREGUE = "DashCliente_FollowUpNaoEntregue",
  ABA_POLITICA_RESUMO = 'Aba_PoliticaResumo',
  ABA_POLITICA_TROCA = 'Aba_PoliticaTrocaDevolucao',
  ABA_DOCUMENTOS_REGULATORIOS = 'Aba_DocumentosRegulatoriosViveo',
  ABA_DADOS_CLIENTE = 'Aba_DadosCliente',
  ABA_ESTATISTICAS_CLIENTE = 'Aba_EstatisticasCliente',
}

export enum produtosAction {
  BUSCAPRODUTO = 'BuscaProduto',
  ESTOQUEDISPONIVEL = 'ConsultaEstoque',
  ESTOQUEDISPONIVELSIM = 'EstoqueDisponívelSim',
  ESTOQUEDISPONIVELNAO = 'EstoqueDisponívelNão',
}

export enum relatoriosAction {
  RELATORIO_USUARIOS = 'Relatório de Usuários',
  ABA_USUARIOS_INTERNOS = 'Aba_UsuariosInternos',
  ABA_USUARIOS_CLIENTES = 'Aba_UsuariosClientes',
  ABA_RELATORIO_DOCUMENTOS_LEGAIS = 'Aba_RelatorioDocumentacaoLegal',
  ABA_RELATORIO_QUALIFICACOES = 'Aba_RelatorioQualificacoes',
  ABA_RELATORIO_PROTOCOLOS_CONSOLIDADOS = 'Aba_RelatorioProtocolosConsolidados',
  ABA_RELATORIO_NPS_LOJAS_FISICAS = 'Aba_RelatorioNPSLojasFísicas',
  ABA_INTEGRACAO_DADOS = 'Aba_IntegracaoDados',
  RELATORIO_USUARIOS_INTERNOS = 'UsuariosInternosCCare',
  RELATORIO_USUARIOS_CLIENTES = 'UsuariosClientesCCare',
  RELATORIO_DOCUMENTOS_LEGAIS = 'DocumentosLegais',
  RELATORIO_QUALIFICACOES = 'Qualificacoes',
  RELATORIO_PROTOCOLOS_CONSOLIDADOS = 'ProtocolosConsolidados'
}

export enum EnumShippingCompany {
  HEADER_TRANSPORTADORA = 'Header_Pedidos',
  MENU_TRANSPORTADORA = 'Menu_Transportadora',
}

export enum portalDashboardAction {
  MENU_PORTAL = 'Menu_Sidebar'
}

export enum dashboardCustomerEvent {
  DASHCLIENTE_SEGUNDAVIABOLETO = 'dashboard_billet',
  DASHCLIENTE_TRACKINGPEDIDO = 'dashboard_tracking',
  DASHCLIENTE_NOTASFISCAIS = 'dashboard_invoice',
  DASHCLIENTE_XMLNFE = 'dashboard_invoice_xml',
  DASHCLIENTE_LAUDOSFICHAS = 'dashboard_sheets_reports',
  DASHCLIENTE_COMPROVANTEENTREGA = 'dashboard_receipt',
  DASHCLIENTE_FALARCOMPRESIDENTE = 'dashboard_talk_president',
  DASHCLIENTE_NOTACORRECAO = 'dashboard_invoice_correction',
  DASHCLIENTE_DOCUMENTOSLEGAIS = 'dashboard_legal_documents',
  DASHCLIENTE_DOCUMENTOSREGULATORIOS = 'dashboard_regulatory_documents',
  DASHCLIENTE_CONSULTAPRODUTOS = 'dashboard_products_query',
  DASHCLIENTE_SOLICITARDEVOLUCAO = 'dashboard_devolution_request',
  DASHCLIENTE_RECLAMACAOTECNICA = 'dashboard_technical_complaint',
  DASHCLIENTE_GERENCIARUSUARIOS = 'dashboard_manage_users',
  DASHCLIENTE_POLITICASNEGOCIO = 'dashboard_business_policies',
  DASHCLIENTE_FALECOMNUTRICIONISTA = "dashboard_talk_nutritionist",
  DASHCLIENTE_FOLLOWUPENTREGAS = "dashboard_delivered_follow_up",
  DASHCLIENTE_FOLLOWUPNAOENTREGUE = "dashboard_not_delivered_follow_up",
};
